module.exports = __webpack_public_path__ + "media/images/pages/bg_nurseryData-9f68ecccddc287b159fd0c9b574e4831.jpg";